import { Component, OnInit } from '@angular/core';
import { SeoDescription, SeoTitle } from '@constants';
import { RouterSlug } from '@enums';
import { CommonService, OutletService, SeoService } from '@services';
import { I18NService } from 'src/core/services/i18n/i18n.service';

@Component({
    selector: 'app-sitemap',
    templateUrl: './sitemap.component.html',
    styleUrls: ['./sitemap.component.scss'],
})
export class SitemapComponent implements OnInit {
    outlets: any = {};
    constructor(
        private outletService: OutletService,
        private commonService: CommonService,
        private i18n: I18NService,
        private seoService: SeoService,
    ) {}

    ngOnInit(): void {
        this.setSEO();
        this.getOutlets();
    }

    setSEO() {
        const title = SeoTitle[this.i18n.currentLang][RouterSlug.SITEMAP];
        const description = SeoDescription[this.i18n.currentLang][RouterSlug.SITEMAP];
        this.seoService.setSEO(title, description);
    }

    getOutlets() {
        this.outletService.getOutlets({ page: 0 }).subscribe((res: any) => {
            if (res.result?.outlets) {
                res.result.outlets.forEach((outlet) => {
                    const country = this.commonService.getCountryName(outlet.country);
                    if (!this.outlets[country]) {
                        this.outlets[country] = {};
                    }
                    if (!this.outlets[country][outlet.city]) {
                        this.outlets[country][outlet.city] = [];
                    }
                    this.outlets[country][outlet.city].push(outlet);
                });
            }
        });
    }

    getCountries() {
        return Object.keys(this.outlets);
    }

    getCities(country) {
        return Object.keys(this.outlets[country]);
    }

    getCityOutlets(country: string, city: string): any {
        return this.outlets[country][city];
    }
}
